import React, {useState} from 'react';
import AnalyticsNavigationTabs from '../../../../../uiToolkit/Analytics/AnalyticsNavigationTabs';
import {courseLevelAnalyticsTabs} from '../../conf';
import GradesTable from '../../../components/GradesTable';
import AnalyticsEmptyState from '../../../../../uiToolkit/Analytics/AnalyticsEmptyState';
import './styles.css';
import {analyticsText} from '../../../analyticsText';
import TableLegend from '../../../components/TableLegend';
import {MappedGradebook} from '../mappers';

interface Props {
  onExport: () => void;
  organizationId: string;
  courseId: string;
  isLoading: boolean;
  gradebook?: MappedGradebook;
}

const CourseAnalyticsOverviewUI = React.memo(
  ({onExport, organizationId, courseId, isLoading, gradebook}: Props) => {
    const [search, setSearch] = useState('');
    const [orderAsc, setOrderAsc] = useState(false);

    const getLearnerRecords = () => {
      let result = [];
      if (orderAsc) {
        result = gradebook!.learnerRecords.sort((x, y) =>
          x.name > y.name ? 1 : -1,
        );
      } else {
        result = gradebook!.learnerRecords!.sort((x, y) =>
          x.name < y.name ? 1 : -1,
        );
      }
      if (search) {
        result = result.filter(x =>
          x.name.toLowerCase().includes(search.toLowerCase()),
        );
      }
      return result;
    };

    return (
      <div>
        <AnalyticsNavigationTabs
          onExport={onExport}
          search={search}
          setSearch={setSearch}
          tabs={courseLevelAnalyticsTabs(organizationId, courseId)}
        />
        <div className="PassingScoreAndLegend">
          {gradebook?.passingScore ? (
            <div className="PassingScoreContainer">
              <span className="icon-icon_score"></span>
              <span className="InfoText">{analyticsText.passingScore}</span>
              <span className="ScoreText">{gradebook?.passingScore}</span>
            </div>
          ) : (
            <div />
          )}
          <TableLegend hideNotStarted />
        </div>
        {gradebook ? (
          <div className="GradesTableContainer">
            <GradesTable
              isLoading={isLoading}
              headerItems={gradebook!.headerItems}
              avgScores={gradebook.avgScores}
              orderAsc={orderAsc}
              setOrderAsc={setOrderAsc}
              learnerRecords={getLearnerRecords()}
            />
          </div>
        ) : (
          <AnalyticsEmptyState />
        )}
      </div>
    );
  },
);

export default CourseAnalyticsOverviewUI;
